import { Typography } from "@material-ui/core";
import { useEventCardStyles } from "@saleor/auditLogs/utils/eventCardStyles";
import React from "react";

interface EventCardHeaderProps {
  eventName: string;
  eventUser: string;
  eventUserActionType?: string;
  showEventItems: boolean;
  showActivity: boolean;
  action(): void;
}

const EventCardHeader: React.FC<EventCardHeaderProps> = props => {
  const {
    eventName,
    eventUser,
    eventUserActionType,
    showEventItems,
    showActivity,
    action
  } = props;
  const classes = useEventCardStyles(props);

  return (
    <>
      <Typography variant="subtitle1" className={classes.eventName}>
        {eventName}
      </Typography>
      <Typography variant="caption">
        {eventUserActionType && eventUserActionType.length > 0 ? (
          <>
            &lt;{eventUserActionType}: {eventUser}&gt;
          </>
        ) : (
          <>{eventUser}</>
        )}

        {showEventItems && (
          <span className={classes.activitySpan} onClick={action}>
            {showActivity ? "Hide" : "Show"} Activity
          </span>
        )}
      </Typography>
    </>
  );
};

export default EventCardHeader;
